import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import Icon from 'ui/atoms/Icon/Icon';
import TextHtml from 'ui/atoms/TextHtml/TextHtml';
import React from 'react';

const DialogPersonalizedProgramExists = ({ t, open, courseName, onCancel, onSuccess }) => {
  return (
    <div>
      <Dialog
        isOpen={open}
        ariaLabel={t('new-course:Personalize')}
        size="l"
        className="dialog-personalize-program"
        onClose={onCancel}
        onCancel={onCancel}
        onSuccess={onSuccess}
        buttonTextSuccess={t('course:Open my version')}
      >
        <div className="personalize-program__wrapper">
          <div className="personalize-program__head">
            <Icon name="pencil" color="primary" size="xl" />
            <div className="personalize-program__head-title">{t('new-course:Personalize')}</div>
          </div>
          <div className="personalize-program__content">
            <div className="personalize-program__subhead">
              <TextHtml text={t('course:You already have a personalized version of x', { name: courseName })} />
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

DialogPersonalizedProgramExists.defaultProps = {
  onCancel: function () {},
  onSuccess: function () {},
  open: false,
};

export default DialogPersonalizedProgramExists;
